import api from './api';

export interface FeaturedGame {
  projectId: string;
  name: string;
  videoUrl: string;
  thumbnailUrl?: string | null;
}

export async function getFeaturedGames(): Promise<FeaturedGame[]> {
  const response = await api.get<FeaturedGame[]>('games/featured');
  return response.data;
}
